import { render, staticRenderFns } from "./PerformanceData.vue?vue&type=template&id=fa72a410&scoped=true"
import script from "./PerformanceData.vue?vue&type=script&lang=js"
export * from "./PerformanceData.vue?vue&type=script&lang=js"
import style0 from "./PerformanceData.vue?vue&type=style&index=0&id=fa72a410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa72a410",
  null
  
)

export default component.exports